import * as React from "react";
import { Box, Typography } from "@mui/material";

import { tl } from "../../components/translate";
import { getToken } from "../../auth/authentication";
import useAssessmentLabel from "../../hooks/useAssessmentLabel";
import { FilesInput } from "../../components/FilesInput/FilesInput";
import useCurrentResourceCentre from "../../hooks/useCurrentResourceCentre";
import { assessmentAttachmentsUrl, deleteAttachmentEndPoint } from "../../api/assessment";

// @ts-expect-error - css
import styles from "./Assessment.module.css";

const Attachment = ({
  assessmentId,
  onfilesChange,
  readOnly = false
}: {
  assessmentId: number;
  onfilesChange: (files: File[]) => void;
  readOnly?: boolean;
}): React.ReactNode => {
  const rc = useCurrentResourceCentre();
  const assessmentLabels = useAssessmentLabel();

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.attachments}
        </Typography>
      </Box>
      <Box className={styles.assessmentField}>
        <FilesInput
          endpoint={assessmentAttachmentsUrl(assessmentId)}
          deleteEndpoint={deleteAttachmentEndPoint()}
          authToken={getToken()}
          attachmentDisabled={readOnly}
          chooseFileLabel={tl("assessment.addAttachmentsMax")}
          maxString={tl("assessment.maxCountString")}
          onfilesChange={onfilesChange}
          sx={{
            width: "100%"
          }}
          maxAttachmentCount={rc?.settings?.assessmentSettings?.attachmentCount ?? 3}
        />
      </Box>
    </Box>
  );
};

export default Attachment;
